module.exports = __webpack_public_path__ + "img/partner08.eb551316.png";